/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Failed_SingleInputs */



/**
* | output |
* | --- |
* | "Failed to export subtitle" |
*
* @param {Batch_Subtitle_Export_Failed_SingleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_failed_single = /** @type {((inputs?: Batch_Subtitle_Export_Failed_SingleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Failed_SingleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l’exportation du sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelexport fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile esportare i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось экспортировать субтитры.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo exportar el subtítulo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao exportar legenda")
	return /** @type {LocalizedString} */ ("Failed to export subtitle")
});